module.exports = __webpack_public_path__ + "img/footer_gaming2.301d1bea.png";